/* eslint-disable unicorn/consistent-function-scoping */
import { EntitlementNames, CurrentUserRoleNames } from './types';
import Entitlements from '../../services/entitlements';
import { AppState, AppThunkDispatch } from '..';

export const getEntitlementAuthorizations =
  () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { envVariables, client },
    } = getState();

    try {
      const service = new Entitlements(envVariables.entitlementsV1BaseUrl, client);
      dispatch({
        type: EntitlementNames.SET_LOADING,
        payload: true,
      });
      const response: any = await service.getEntitlementAuthorizations({
        includeAppPermissions: true,
        includeDataPermissions: false,
      });
      dispatch({
        type: EntitlementNames.SET_AUTHORIZATIONS,
        payload: response.data.authorization,
      });
    } catch (error) {
      dispatch({
        type: EntitlementNames.SET_ERROR,
        payload: true,
      });
    }
    dispatch({
      type: EntitlementNames.SET_LOADING,
      payload: false,
    });
  };

export const updateLastLoginUser =
  () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { envVariables, client },
    } = getState();

    const service = new Entitlements(envVariables.entitlementsV1BaseUrl, client);
    await service.updateLastLoginUserDetails();
  };

function getFirstRoleName(parties: any[]) {
  let userRoleName = "";
  parties.forEach((partie: any) => {
    if (partie.roles && partie.roles.length > 0) {
      userRoleName = partie.roles[0].roleName;
    }
  });
  return userRoleName;
}

export const getUserRole =
  () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { envVariables, client },
    } = getState();

    const service = new Entitlements(envVariables.entitlementsV1BaseUrl, client);
    const response: any = await service.getUserRoleDetails();

    const parties: any[] = response.data.parties || [];
    const userRoleName: string = getFirstRoleName(parties);
    dispatch({
      type: CurrentUserRoleNames.SET_CURRENT_USER_ROLE,
      userRoleName,
    });
  };